import { render, staticRenderFns } from "./JoinUsForm.vue?vue&type=template&id=2a71f2ca&"
import script from "./JoinUsForm.vue?vue&type=script&lang=js&"
export * from "./JoinUsForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports